import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import { emptyImage, getCloudImageUrl } from 'utils';
import {
  accessoriesCondition,
  boxCondition,
  boxHandbag,
  dustBag,
  formatCurrency,
  handbagCondition,
  sneakersCondition,
  sneakersDefect,
  displayItem,
  yellowing,
  sneakerDefectsCondition,
  handleStatusConsignment,
  handleColorStatusConsignment,
} from 'utils/Helpers';

const Completed = ({ data, ratio, currency, luxuryDetail, sneakersDetail }) => {
  const customerPaid = data?.offer?.[0]?.sale?.[0]?.customer_paid;
  
  return (
    <>
      <div className={'grey-box-section'}>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Consignment ID</p>
            <p className={'value'}>{data?.consignment_id}</p>
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Order ID</p>
            <p className={'value'}>{data?.offer?.[0]?.invoice_number}</p>
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Product Conditions</p>
            <p className={'value'}>
              {data?.product_variant?.product?.category.name === 'handbags'
                ? luxuryDetail
                : sneakersDetail}
            </p>
          </div>
        </div>
        {data?.hypequarter_display && (
          <div className={'hq-wrapper'}>
            <p className={'hq-text'}>Hypequarter Display</p>
          </div>
        )}
      </div>
      <div className={'price-seller-section-outline'}>
        <div className={'item'}>
          <p className={'title'}>Price Sold</p>
          <p className={'value'}>
            {formatCurrency(data?.asking_price, ratio, currency)}
          </p>
        </div>
        <div className={'item'}>
          <p className={'title'}>Current Lowest Ask</p>
          <p className={'value'}>
            {formatCurrency(data?.asking_price, ratio, currency)}
          </p>
        </div>
      </div>
      <div className={'price-seller-section-outline'}>
        <div className={'item'}>
          <p className={'title'}>Date Consigned</p>
          <p className={'value'}>
            {data?.created_at
              ? moment(data?.created_at).format('MMMM DD, YYYY')
              : '-'}
          </p>
        </div>
        <div className={'item'}>
          <p className={'title'}>Date Sold</p>
          <p className={'value'}>
            {customerPaid
              ? moment(customerPaid).format('MMMM DD, YYYY')
              : '-'}
          </p>
        </div>
      </div>
    </>
  );
};

const Cancelled = ({ data, ratio, currency, luxuryDetail, sneakersDetail }) => {
  return (
    <div className={'grey-box-section'}>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Consignment ID</p>
          <p className={'value'}>{data?.consignment_id}</p>
        </div>
      </div>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Consignment Price</p>
          <p className={'value'}>
            {formatCurrency(data?.asking_price, ratio, currency)}
          </p>
        </div>
      </div>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Date Cancelled</p>
          <p className={'value'}>
            {data?.updated_at
              ? moment(data?.updated_at).format('MMMM DD, YYYY')
              : '-'}
          </p>
        </div>
      </div>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Product Conditions</p>
          <p className={'value'}>
            {data?.product_variant?.product?.category.name === 'handbags'
              ? luxuryDetail
              : sneakersDetail}
          </p>
        </div>
      </div>
      {data?.hypequarter_display && (
        <div className={'hq-wrapper'}>
          <p className={'hq-text'}>Hypequarter Display</p>
        </div>
      )}
    </div>
  );
};

const Approved = ({ data, ratio, currency, luxuryDetail, sneakersDetail }) => {
  return (
    <>
      <div className={'grey-box-section'}>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Consignment ID</p>
            <p className={'value'}>{data?.consignment_id}</p>
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Consignment Price</p>
            <p className={'value'}>
              {formatCurrency(data?.asking_price, ratio, currency)}
            </p>
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Product Conditions</p>
            <p className={'value'}>
              {data?.product_variant?.product?.category.name === 'handbags'
                ? luxuryDetail
                : sneakersDetail}
            </p>
          </div>
        </div>
        {data?.hypequarter_display && (
          <div className={'hq-wrapper'}>
            <p className={'hq-text'}>Hypequarter Display</p>
          </div>
        )}
      </div>
      <div className={'yellow-box-section'}>
        <p>
          Unfortunately, we cannot approve your consignment request for this
          item. However, we have created a standard listing for your item, which
          you can check in the Selling Dashboard. Thank you.
        </p>
      </div>
    </>
  );
};

const Returned = ({ data, ratio, currency, luxuryDetail, sneakersDetail }) => {
  return (
    <div className={'grey-box-section'}>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Consignment ID</p>
          <p className={'value'}>{data?.consignment_id}</p>
        </div>
      </div>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Consignment Price</p>
          <p className={'value'}>
            {formatCurrency(data?.asking_price, ratio, currency)}
          </p>
        </div>
      </div>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Receive At</p>
          <p className={'value'}>
            {data?.updated_at
              ? moment(data?.updated_at).format('MMMM DD, YYYY')
              : '-'}
          </p>
        </div>
      </div>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Product Conditions</p>
          <p className={'value'}>
            {data?.product_variant?.product?.category.name === 'handbags'
              ? luxuryDetail
              : sneakersDetail}
          </p>
        </div>
      </div>
      {data?.hypequarter_display && (
          <div className={'hq-wrapper'}>
            <p className={'hq-text'}>Hypequarter Display</p>
          </div>
        )}
    </div>
  );
};

const Rejected = ({ data, ratio, currency, luxuryDetail, sneakersDetail }) => {
  return (
    <div className={'grey-box-section'}>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Consignment ID</p>
          <p className={'value'}>{data?.consignment_id}</p>
        </div>
      </div>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Consignment Price</p>
          <p className={'value'}>
            {formatCurrency(data?.asking_price, ratio, currency)}
          </p>
        </div>
      </div>
      <div className={'container-row'}>
        <div className={'item'}>
          <p className={'title'}>Product Conditions</p>
          <p className={'value'}>
            {data?.product_variant?.product?.category.name === 'handbags'
              ? luxuryDetail
              : sneakersDetail}
          </p>
        </div>
      </div>
      {data?.hypequarter_display && (
        <div className={'hq-wrapper'}>
          <p className={'hq-text'}>Hypequarter Display</p>
        </div>
      )}
    </div>
  );
};

interface IModalHistoryProps {
  isOpen: boolean;
  ratio?: number;
  currency?: string;
  data: any;
  onToggle: () => any;
  type: string;
}

const ModalHistoryComponent: React.FC<IModalHistoryProps> = (props) => {
  const { isOpen, onToggle, ratio, currency, data, type } = props;
  // If data is available, then show the modal
  if (data) {
    const isDefects = data?.defects?.length > 0;
    const uniqueDefects = _.uniqBy(isDefects ? data?.defects : null, 'name');
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG' && a.value)
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'BOX')
      : {};
    const hideBoxInfo = data?.product_variant?.hide_box_info;
    const isVintage = data?.product_variant?.vintage;
    const sneakersDetailArr = [
      isVintage ? 'Vintage' : sneakersCondition(data?.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(data?.box_condition),
      accessoriesCondition(data?.missing_accessories),
      yellowing(data?.yellowing),
      displayItem(data?.display_item),
      sneakersDefect(data?.sneakers_defect),
      isDefects ? sneakerDefectsCondition(uniqueDefects, ', ') : '',
    ];
    const sneakersDetail = sneakersDetailArr
      .filter((item) => item !== '')
      .map((items) => items)
      .join(', ');
    const luxuryDetailArr = [
      sneakersCondition(data?.sneakers_condition),
      accessoriesCondition(data?.missing_accessories),
      dustBag(dustBagCondition),
      hideBoxInfo ? '' : boxHandbag(boxConditions),
      isDefects ? handbagCondition(uniqueDefects, ', ') : '',
    ];
    const luxuryDetail = luxuryDetailArr
      .filter((item) => item !== '' && item !== 'Missing Box')
      .map((item) => item)
      .join(', ');
    const category = data?.product_variant?.product?.category.name;
    const imageUrl = data?.product_variant?.product_variant_images?.length
      ? data?.product_variant?.product_variant_images[0].URL
      : null;
    const txtStatus = handleStatusConsignment(data, type);
    const isGreenStatus = handleColorStatusConsignment(txtStatus, data?.product_variant?.SKU) === '#159953'
    const isYellowStatus = handleColorStatusConsignment(txtStatus, data?.product_variant?.SKU) === '#FFCA25'

    return (
      <Modal
        className="offer-detail-modal"
        toggle={onToggle}
        isOpen={isOpen}
        centered
      >
        <>
          <div className={'content-modal'}>
            <div className={'header-section'}>
              <div className={'left'}>
                <p className={'product-title'}>
                  {data?.product_variant?.display_name}
                </p>
                <p className={'product-sku'}>{data?.product_variant?.SKU}</p>
              </div>
              <div className={'right'}>
                <div>
                  {category === 'handbags' ||
                  (category === 'lifestyles' &&
                    data?.size?.US.toLowerCase() !== 'all size') ? (
                    <div className={'size-container'}>
                      <p>{data?.size?.US}</p>
                    </div>
                  ) : (
                    <div className={'size-container'}>
                      <p>US {data?.size?.US}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={'image-section'}>
              <img
                src={
                  imageUrl
                    ? getCloudImageUrl(imageUrl, 300)
                    : emptyImage(category)
                }
              />
            </div>
            <div
              className={classNames('status-section', {
                'green': isGreenStatus,
                'yellow': isYellowStatus,
              })}
            >
              <p>{txtStatus}</p>
            </div>

            {txtStatus === 'Completed' ? (
              <Completed
                data={data}
                ratio={ratio}
                currency={currency}
                luxuryDetail={luxuryDetail}
                sneakersDetail={sneakersDetail}
              />
            ) : txtStatus === 'Cancelled' ? (
              <Cancelled
                data={data}
                ratio={ratio}
                currency={currency}
                luxuryDetail={luxuryDetail}
                sneakersDetail={sneakersDetail}
              />
            ) : txtStatus === 'Approved as Online Listing' ? (
              <Approved
                data={data}
                ratio={ratio}
                currency={currency}
                luxuryDetail={luxuryDetail}
                sneakersDetail={sneakersDetail}
              />
            ) : txtStatus === 'Returned' ? (
              <Returned
                data={data}
                ratio={ratio}
                currency={currency}
                luxuryDetail={luxuryDetail}
                sneakersDetail={sneakersDetail}
              />
            ) : txtStatus === 'Consignment Rejected' ? (
              <Rejected
                data={data}
                ratio={ratio}
                currency={currency}
                luxuryDetail={luxuryDetail}
                sneakersDetail={sneakersDetail}
              />
            ) : (
              <Rejected
                data={data}
                ratio={ratio}
                currency={currency}
                luxuryDetail={luxuryDetail}
                sneakersDetail={sneakersDetail}
              />
            )}
          </div>
        </>
      </Modal>
    );
  }
  // Not rendering the modal component is data is unavailable to prevent undefined error
  return <div />;
};

const mapStateToProps = (state) => {
  return {
    currency: state.dataAuth.userCurrency.currency,
    ratio: state.dataAuth.userCurrency.ratio,
  };
};

export default connect(mapStateToProps, null)(ModalHistoryComponent);
